import {
  createSlice,
  createEntityAdapter,
  createSelector,
} from "@reduxjs/toolkit";
import {
  fetchCategories,
  createCategory,
  deleteCategory,
  updateCategory,
} from "./thunk";

export const categoriesAdapter = createEntityAdapter({
  sortComparer: (a, b) => b.createdAt.localeCompare(a.createdAt),
});

const initialState = categoriesAdapter.getInitialState({
  isLoading: false,
  meta: {},
});

// slice
const categoriesSlice = createSlice({
  name: "categories",
  initialState: initialState,

  extraReducers: (builder) => {
    builder.addCase(fetchCategories.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchCategories.fulfilled, (state, { payload }) => {
      categoriesAdapter.setAll(state, payload.data);
      state.meta = payload.meta || {};
      state.isLoading = false;
    });
    builder.addCase(fetchCategories.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(createCategory.fulfilled, (state, { payload }) => {
      categoriesAdapter.addOne(state, payload.data);

      state.meta.total += 1;
      state.isLoading = false;

      // if (state.ids.length > state.meta.perPage) {
      //   categoriesAdapter.removeOne(state, state.ids[state.meta.perPage]);
      // }
    });
    builder.addCase(updateCategory.fulfilled, (state, { payload }) => {
      categoriesAdapter.updateOne(state, {
        id: payload.data._id,
        changes: payload.data,
      });
    });
    builder.addCase(deleteCategory.fulfilled, (state, { payload }) => {
      categoriesAdapter.removeOne(state, payload.data._id);
      state.meta.total -= 1;
    });
  },
});

// global

const categoryInputSelector = (state) => state.categories;

const categoriesSelectors = categoriesAdapter.getSelectors(
  categoryInputSelector
);

export const getCategoriesSelector = (state) =>
  categoriesSelectors.selectAll(state);

export const categoryDataSelector = createSelector(
  getCategoriesSelector,
  categoryInputSelector,
  (categoriesData, categories) => {
    return {
      data: categoriesData,
      ...categories,
    };
  }
);

export const categoryListDataSelector = createSelector(
  getCategoriesSelector,
  (categories) => {
    return categories.map((category) => ({
      name: category.name,
      _id: category._id,
    }));
  }
);

export default categoriesSlice.reducer;
